import React from 'react';
import BannerSlider from '../components/Banner';
import KeyFinancingSolutions from '../components/KeyFinancingSolutions';
import WhoWeAre from '../components/WhoWeAre';
import TheCashProEdge from '../components/TheCashProEdge';
import GuidingPrinciples from '../components/GuidingPrinciples';
import Testimonials from '../components/Testimonials';
import ContactSection from '../components/ContactSection';
import ContactPopup from '../components/ContactPopup';

const Home = () => {
  return (
    <>
      <ContactPopup />
      <BannerSlider />
      <KeyFinancingSolutions />
      <WhoWeAre />
      <TheCashProEdge />
      <GuidingPrinciples />
      <Testimonials />
      <ContactSection />
    </>
  );
};

export default Home;
